<template>
  <v-card class="pa-0" style="height: 100%;">
    <div class="d-flex justify-space-between align-items-center pb-0 pt-6 px-6">
      <h5 class="text-uppercase align-self-center">Báo cáo khách hàng thành công</h5>
    </div>
    <v-card-text class="pa-6">
      <div class="d-flex">
        <div style="flex: 1;">
          <v-select
            prepend-icon="mdi-account-outline"
            item-text="title"
            item-value="value"
            placeholder="Nhân viên sale"
            v-model="defaultSaleUser"
            :items="formattedUsers"
            outlined
            dense
            hide-details
            @input="handleSelection"
            class="pa-0"
          />
        </div>
        <div style="width: 24px;"></div>
        <div style="flex: 1;">
          <ReportDateRange @change="changeDateRange" @cleared="dateCleared" />
        </div>
      </div>
      <BarChart :chartdata="barChart" :options="barChartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BarChart from './BarChart.vue'
import ReportDateRange from './ReportDateRange.vue'

export default {
  props: {
    users: Array
  },
  data() {
    return {
      barChartOptions: {},
      barChart: {},
      saleUser: '',
      query: {}
    }
  },
  components: {BarChart, ReportDateRange},
  mounted() {
    this.getChartData()
  },
  computed: {
    ...mapGetters('auth', ['user']),
    formattedUsers() {
      let options = this.users.map(u => ({title: u.name ? u.name : u.username, value: u.id}))
      if (this.user.role.type === 'admin') {
        options.unshift({title: 'Tất cả nhân viên', value: ''})
      }
      return options
    },
    defaultSaleUser() {
      return this.user && this.user.role.type === 'admin' ? '' : this.user ? this.user.id : null
    }
  },
  methods: {
    ...mapActions('lead', ['countStatus', 'countSucceed']),
    async changeDateRange(data) {
      this.query.createdAt_gt = data[0]
      this.query.createdAt_lt = data[1]
      await this.getChartData()
    },

    async handleSelection(data) {
      this.query.inCharge = data
      await this.getChartData()
    },

    async getChartData() {
      this.$loading.active = true
      const query = this.user.role.type === 'admin' ? this.query : {...this.query, inCharge: this.user.id}
      const counts = await this.countSucceed(query)
      this.updateBarChart(counts)

      this.$loading.active = false
    },

    async dateCleared() {
      delete this.query.createdAt_gt
      delete this.query.createdAt_lt
      await this.getChartData()
    },
    updateBarChart(counts) {
      const labels = counts.map(item => item.name)
      const countAllData = counts.map(item => item.countAll)
      const countSucceedData = counts.map(item => item.countSucceed)

      const maxDataValue = Math.max(...countAllData, ...countSucceedData)

      const yAxisMax = Math.ceil(maxDataValue * 1.2)

      this.barChart = {
        labels: labels,
        datasets: [
          {
            label: 'Khách hàng thành công',
            backgroundColor: '#66BB6A',
            data: countSucceedData
          },
          {
            label: 'Tổng khách hàng tiềm năng',
            backgroundColor: '#42A5F5',
            data: countAllData
          }
        ]
      }

      this.barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                max: yAxisMax
              }
            }
          ]
        }
      }
    }
  }
}
</script>
